window.log = () => {};
if (import.meta.env.DEV) {
	window.log = console.log; // eslint-disable-line no-console
}
